import React, { useEffect } from 'react';
import Swiper from 'swiper';
import 'swiper/css'; // Import Swiper styles
import 'swiper/css/pagination'; // Import Pagination styles
import clientsLogo from "../../assets/img/customers/clients-logo-01.png"


const ClientSection = () => {
    useEffect(() => {
        new Swiper('.clients-carousel', {
            loop: true,
            spaceBetween: 20,
            slidesPerView: 5,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                480: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                },
                1280: {
                    slidesPerView: 5,
                },
            },
        });
    }, []);

    return (
        <section className="client-section ptb-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="section-heading text-center mb-5">
                            <h2>Lots of Customer Love Us</h2>
                            <p>
                                Rapidiously morph transparent internal or sources whereas resource sucking e-business. Conveniently innovate formulate manufactured products compelling internal.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-md-12">
                        <div className="clients-carousel swiper">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <div className="item single-customer">
                                        <img src={clientsLogo} alt="client logo" className="customer-logo" />
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="item single-customer">
                                        <img src={clientsLogo} alt="client logo" className="customer-logo" />
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="item single-customer">
                                        <img src={clientsLogo} alt="client logo" className="customer-logo" />
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="item single-customer">
                                        <img src={clientsLogo} alt="client logo" className="customer-logo" />
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="item single-customer">
                                        <img src={clientsLogo} alt="client logo" className="customer-logo" />
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="item single-customer">
                                        <img src={clientsLogo} alt="client logo" className="customer-logo" />
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="item single-customer">
                                        <img src={clientsLogo} alt="client logo" className="customer-logo" />
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="item single-customer">
                                        <img src={clientsLogo} alt="client logo" className="customer-logo" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ClientSection;
